import React from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import { FormattedMessage } from '../../util/reactIntl';
import { stringify } from '../../util/urlHelpers';

import NamedLink from '../NamedLink/NamedLink';

import css from './ReportLink.module.css';

/**
 * Low-prominence link to the trust and safety report flow with structured context.
 *
 * @component
 * @param {Object} props
 * @param {'listing'|'profile'|'transaction'|'general'} props.contextType
 * @param {string} [props.contextId]
 * @param {string} [props.contextLabel]
 * @param {string} [props.listingId]
 * @param {string} [props.userId]
 * @param {string} [props.transactionId]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
const ReportLink = props => {
  const {
    className,
    contextType = 'general',
    contextId,
    contextLabel,
    listingId,
    userId,
    transactionId,
    children,
  } = props;
  const location = useLocation();
  const search = stringify({
    type: contextType,
    id: contextId,
    label: contextLabel,
    listingId,
    userId,
    transactionId,
    path: `${location.pathname}${location.search || ''}`,
  });

  return (
    <NamedLink className={classNames(css.root, className)} name="ReportPage" to={{ search }}>
      {children || <FormattedMessage id="ReportLink.label" />}
    </NamedLink>
  );
};

export default ReportLink;
